import React from "react"
import { Button, Modal } from "antd"

const ProjectSendToGas = ({ rowData, mainProps, setErrorMessage }) => {
  const handleClick = async () => {
    Modal.confirm({
      title: "ارسال پرونده",
      content: "از ارسال پرونده به شرکت گاز اطمینان دارید؟",
      okText: "بله",
      cancelText: "خیر",
      onOk: async () => {
        const { onSendGasProjectToGas } = mainProps
        await onSendGasProjectToGas(rowData.fileNumber)
      },
    })
  }

  return (
    <div style={{ display: "inline-block" }}>
      <Button
        type="primary"
        size="small"
        onClick={handleClick}
        disabled={!rowData.isOk}
      >
        {rowData.solarDateSendToCoGas
          ? `ارسال: ${rowData.solarDateSendToCoGas} `
          : "ارسال"}
      </Button>
    </div>
  )
}

export default ProjectSendToGas
